import { ChatDescription } from 'types/chatsType';

type UpdateUnreadMessagesCounterParams = {
  chats: ChatDescription[];
  dialogId: number;
  messagesMarkedAsRead: number[];
};

export const updateUnreadMessagesCounter = ({
  chats,
  dialogId,
  messagesMarkedAsRead,
}: UpdateUnreadMessagesCounterParams): ChatDescription[] =>
  chats.map((chat) => {
    if (chat.id === dialogId) {
      const { unreadMessageCount } = chat;
      let newUnreadMessages = unreadMessageCount - messagesMarkedAsRead.length;
      if (newUnreadMessages < 0) newUnreadMessages = 0;
      return { ...chat, unreadMessageCount: newUnreadMessages };
    }
    return chat;
  });
